export const IMPORT_BOARDS = 'cboard/Board/IMPORT_BOARDS';
export const ADD_BOARDS = 'cboard/Board/ADD_BOARDS';
export const CREATE_BOARD = 'cboard/Board/CREATE_BOARD';
export const UPDATE_BOARD = 'cboard/Board/UPDATE_BOARD';
export const DELETE_BOARD = 'cboard/Board/DELETE_BOARD';
export const CHANGE_BOARD = 'cboard/Board/CHANGE_BOARD';
export const REPLACE_BOARD = 'cboard/Board/REPLACE_BOARD';
export const SWITCH_BOARD = 'cboard/Board/SWITCH_BOARD';
export const PREVIOUS_BOARD = 'cboard/Board/PREVIOUS_BOARD';
export const TO_ROOT_BOARD = 'cboard/Board/TO_ROOT_BOARD';
export const CREATE_TILE = 'cboard/Board/CREATE_TILE';
export const DELETE_TILES = 'cboard/Board/DELETE_TILES';
export const EDIT_TILES = 'cboard/Board/EDIT_TILES';
export const FOCUS_TILE = 'cboard/Board/FOCUS_TILE';
export const CLICK_SYMBOL = 'cboard/Board/CLICK_SYMBOL';
export const CLICK_OUTPUT = 'cboard/Board/CLICK_OUTPUT';
export const CHANGE_OUTPUT = 'cboard/Board/CHANGE_OUTPUT';
export const CHANGE_IMPROVED_PHRASE = 'cboard/Board/CHANGE_IMPROVED_PHRASE';
export const CHANGE_LIVE_MODE = 'cboard/Board/CHANGE_LIVE_MODE';
export const HISTORY_REMOVE_BOARD = 'cboard/Board/HISTORY_REMOVE_BOARD';
export const UNMARK_BOARD = 'cboard/Board/UNMARK_BOARD';
export const UNMARK_SHOULD_CREATE_API_BOARD =
  'cboard/Board/UNMARK_SHOULD_CREATE_API_BOARD';
export const CREATE_API_BOARD_SUCCESS = 'cboard/Board/CREATE_API_BOARD_SUCCESS';
export const CREATE_API_BOARD_FAILURE = 'cboard/Board/CREATE_API_BOARD_FAILURE';
export const CREATE_API_BOARD_STARTED = 'cboard/Board/CREATE_API_BOARD_STARTED';
export const DELETE_API_BOARD_SUCCESS = 'cboard/Board/DELETE_API_BOARD_SUCCESS';
export const DELETE_API_BOARD_FAILURE = 'cboard/Board/DELETE_API_BOARD_FAILURE';
export const DELETE_API_BOARD_STARTED = 'cboard/Board/DELETE_API_BOARD_STARTED';
export const UPDATE_API_BOARD_SUCCESS = 'cboard/Board/UPDATE_API_BOARD_SUCCESS';
export const UPDATE_API_BOARD_FAILURE = 'cboard/Board/UPDATE_API_BOARD_FAILURE';
export const UPDATE_API_BOARD_STARTED = 'cboard/Board/UPDATE_API_BOARD_STARTED';
export const GET_API_MY_BOARDS_SUCCESS =
  'cboard/Board/GET_API_MY_BOARDS_SUCCESS';
export const GET_API_MY_BOARDS_FAILURE =
  'cboard/Board/GET_API_MY_BOARDS_FAILURE';
export const GET_API_MY_BOARDS_STARTED =
  'cboard/Board/GET_API_MY_BOARDS_STARTED';
export const DOWNLOAD_IMAGES_SUCCESS = 'cboard/Board/DOWNLOAD_IMAGES_SUCCESS';
export const DOWNLOAD_IMAGES_FAILURE = 'cboard/Board/DOWNLOAD_IMAGES_FAILURE';
export const DOWNLOAD_IMAGES_STARTED = 'cboard/Board/DOWNLOAD_IMAGES_STARTED';
export const DOWNLOAD_IMAGE_SUCCESS = 'cboard/Board/DOWNLOAD_IMAGE_SUCCESS';
export const DOWNLOAD_IMAGE_FAILURE = 'cboard/Board/DOWNLOAD_IMAGE_FAILURE';
export const DEFAULT_ROWS_NUMBER = 5;
export const DEFAULT_COLUMNS_NUMBER = 5;
export const SHORT_ID_MAX_LENGTH = 14;
